var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBillingClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33366 11.8307L0.166992 10.6641L4.83366 5.9974L0.166992 1.33073L1.33366 0.164062L6.00033 4.83073L10.667 0.164062L11.8337 1.33073L7.16699 5.9974L11.8337 10.6641L10.667 11.8307L6.00033 7.16406L1.33366 11.8307Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBillingClose);
export default __webpack_public_path__ + "static/media/icon-billing-close.c5cf6a9a72aa0c6b6b08530de0089273.svg";
export { ForwardRef as ReactComponent };